/** Home → quick actions (universal QuickActionGroup, module "home"; role-aware, pinnable). */
import { QuickActionGroup } from "@/components/quickactions/QuickActionGroup";

export function QuickActions() {
  return <QuickActionGroup module="home" max={17} testid="home-quick-actions" className="mb-0" />;
}
